import { DeviceGeneralType } from '@cobliteam/api-lib/src/__generated__/graphql';
import { isStreamaxDeviceModel } from '@cobliteam/common-types';
import { useGetDevices } from '../../useEntity/useDevices';

const useCameraTypes = () => {
  const { data: devices, isLoading, isError, refetch } = useGetDevices({});
  const distinctGeneralTypes = new Set((devices || []).map((device) => device.generalType));

  const hasCobliCamMulti = () => {
    return distinctGeneralTypes.has(DeviceGeneralType.Multicam);
  };

  const hasCobliCamFadiga = () => {
    return (devices || []).some((device) => device.deviceModel?.toUpperCase().includes('JC400AD'));
  };

  const hasStreamax = () => {
    return (devices || []).some((device) => isStreamaxDeviceModel(device.deviceModel));
  };

  return {
    hasCobliCamMulti,
    hasCobliCamFadiga,
    hasStreamax,
    /**
     * The `has*` helpers answer `false` while the device list is in flight or failed, which is
     * indistinguishable from "the fleet doesn't have this camera". Callers that gate UI on them
     * need these flags to tell the three cases apart.
     */
    isLoading,
    isError,
    refetch,
  };
};

export default useCameraTypes;
